import { IActivityBodyContentProps } from "../../../properties/ActivityProperties";
import ShowBodyMediaByContentType from "./ShowBodyMediaByContentType";

const ActivityBodyContent = ({
  templateType,
  bodyMap,
  contentMap,
  answerMap,
}: IActivityBodyContentProps) => {
  if (!bodyMap) return null;

  const processBodyValue = (
    bodyValue: string,
    contentType: string,
    answerMap: string[],
    startIndex: number,
  ) => {
    let currentQQIndex = startIndex;
    let processedValue = bodyValue;

    while (processedValue.includes("@@")) {
      const answer = answerMap[currentQQIndex];

      const isEmpty =
        answer === undefined ||
        answer === null ||
        answer === "" ||
        answer === "DEFAULT_OPTION" ||
        (typeof answer === "string" && answer.trim() === "");

      if (isEmpty) {
        processedValue = processedValue.replace(
          "@@",
          () => `----(${currentQQIndex + 1})----`,
        );
      } else {
        const trimmedAnswer =
          typeof answer === "string" ? answer.trim() : String(answer);

        switch (contentType) {
          case "TEXT":
            processedValue = processedValue.replace(
              "@@",
              () => `--TEXT--${trimmedAnswer}--TEXT--`,
            );
            break;
          case "IMAGE":
            processedValue = processedValue.replace(
              "@@",
              () => `--IMAGE--${trimmedAnswer}--IMAGE--`,
            );
            break;
          case "VIDEO":
            processedValue = processedValue.replace(
              "@@",
              () => `--VIDEO--${trimmedAnswer}--VIDEO--`,
            );
            break;
          case "AUDIO":
            processedValue = processedValue.replace(
              "@@",
              () => `--AUDIO--${trimmedAnswer}--AUDIO--`,
            );
            break;
          default:
            processedValue = processedValue.replace("@@", () => trimmedAnswer);
        }
      }
      currentQQIndex++;
    }

    return {
      processedValue,
      currentQQIndex,
    };
  };

  let globalAnswerIndex = 0;

  const processedBodies = Object.keys(bodyMap)
    .map((key) => {
      let body;
      try {
        body = JSON.parse(bodyMap[key]);
      } catch (error) {
        console.error(`Error parsing body at key ${key}:`, error);
        return null;
      }

      if (["DROPDOWN", "FILL_IN_THE_BLANKS"].includes(templateType)) {
        const contentType = contentMap["type"];
        const result = processBodyValue(
          body.value,
          contentType,
          answerMap,
          globalAnswerIndex,
        );
        body.value = result.processedValue;
        globalAnswerIndex = result.currentQQIndex;
      }

      return {
        ...body,
        key,
      };
    })
    .filter(Boolean);

  const isPassage = templateType === "PASSAGE";
  const isOpenEnded = templateType === "OPEN_ENDED";
  // Newspaper figure-float: passage floats a portrait image right; open-ended
  // floats any image left so the question stays compact above the answer area.
  const floatMode: "portrait" | "any" | undefined = isPassage
    ? "portrait"
    : isOpenEnded
      ? "any"
      : undefined;
  const listModifier = isPassage
    ? " am-body-list--passage"
    : isOpenEnded
      ? " am-body-list--oe"
      : "";

  return (
    <div className={`am-body-list${listModifier}`}>
      {processedBodies.map((body, index) => {
        // Float only when a text block follows the image (so there's prose to
        // wrap around it); otherwise it renders as a full-width block.
        const canFloat =
          !!floatMode && processedBodies[index + 1]?.type === "TEXT";
        return (
          <ShowBodyMediaByContentType
            key={`body-${body.key}-${index}`}
            index={index}
            type={body.type}
            value={body.value}
            size={body.size}
            floatMode={floatMode}
            canFloat={canFloat}
          />
        );
      })}
    </div>
  );
};

export default ActivityBodyContent;
